"use client"

import { useQuery } from "@tanstack/react-query"
import { getGenerations } from "@/features/generation/actions"
import { queryKeys } from "@/shared/lib/query-keys"
import type { GenerationRow } from "@/shared/lib/supabase/types"

export function useGenerations() {
  return useQuery<GenerationRow[]>({
    queryKey: queryKeys.generations.all(),
    queryFn: () => getGenerations() as Promise<GenerationRow[]>,
  })
}
